interface LeadFilters {
  search: string; activeTab: string; filterLostReason: string; filterPriority: string;
  filterSourceKeys: string[]; filterCustomerType: string; filterOwner: string; scope: string;
  filterDateFrom: string; filterDateTo: string; filterDateType: string;
}

export function buildLeadsListParams(f: LeadFilters): Record<string, string> {
  const params: Record<string, string> = {};
  if (f.search) params.q = f.search;
  if (f.activeTab !== 'all') params.stage = f.activeTab;
  if (f.activeTab === 'lost' && f.filterLostReason) params.lostReason = f.filterLostReason;
  if (f.filterPriority) params.priority = f.filterPriority;
  if (f.filterSourceKeys.length) params.source = f.filterSourceKeys.join(',');
  if (f.filterCustomerType) params.customerType = f.filterCustomerType;
  if (f.filterOwner) params.owner = f.filterOwner;
  if (f.scope) params.scope = f.scope;
  if (f.filterDateFrom || f.filterDateTo) {
    params.dateType = f.filterDateType;
    if (f.filterDateFrom) params.dateFrom = f.filterDateFrom;
    if (f.filterDateTo) params.dateTo = f.filterDateTo;
  }
  return params;
}
